import {
  inventoryItemIdFormat,
  locationIdFormat,
} from "@redotech/redo-inventory-id";
import * as z from "zod";
import { ShippingLabelReviewFields } from "./get-shipping-label-scan-review";

/**
 * Confirms the reviewed label fields, creates the offline return for the
 * identified merchant team, and promotes the UNKNOWN item to RETURN kind.
 */
export const confirmShippingLabelScanReview = {
  name: "confirmShippingLabelScanReview" as const,
  input: z.object({
    inventoryItemId: inventoryItemIdFormat.schema,
    // Null for the no-label offline path: fields are entered manually and
    // the item must have no scan to review.
    scanId: z.string().nullable(),
    /** Mongo Team ObjectId hex of the identified merchant */
    merchantTeamId: z.string(),
    /** Station identity, checked against the warehouse layout's
     *  offline-returns flag */
    locationId: locationIdFormat.schema,
    workstationId: z.string().nullable(),
    fields: ShippingLabelReviewFields,
  }),
  output: z.object({ returnId: z.string() }),
};
